import React from 'react';
import cx from 'classnames';

import styles from './Icon.module.scss';
import { THEME } from '../../../config/commons';

// 'none' because there are icons that do not need concat the type 'fill' or 'line'
export type IconType = 'line' | 'fill' | 'view' | 'none';

export interface IconProps {
  id?: string;
  name: string;
  type?: IconType;
  className?: string;
  theme?: THEME;
}

export default function Icon (props: IconProps) {
  const {
    id,
    name,
    type = 'line',
    className,
    theme = THEME.DARK,
  } = props;

  const isDarkTheme = theme === 'dark';
  // if icon has not available fill or line types, send none to do not concat the type
  const iconName = type === 'none' ? `ri-${name}` : `ri-${name}-${type}`;

  return <i
    id={id}
    className={cx(iconName, styles.lrvIcon, isDarkTheme ? styles.iconDark : styles.iconLight, className)}
  />;
}
